import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUserAuth from './userAuth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserAuthEffects } from './userAuth.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromUserAuth.userAuthFeatureKey, fromUserAuth.reducer),
    EffectsModule.forFeature([UserAuthEffects])
  ]
})
export class UserAuthModule { }